import React from "react";
import { Helmet } from "react-helmet";

import INFO from "../../data/user";
import SEO_DATA, { CANONICAL_URL, DEFAULT_IMAGE } from "../../data/seo";

const buildAbsoluteUrl = (path = "/") => {
	if (/^https?:\/\//i.test(path)) {
		return path;
	}

	return `${CANONICAL_URL}${path.startsWith("/") ? path : `/${path}`}`;
};

const SEO = ({ page, title, description, keywords, path, noindex, image, type = "website", schema = [] }) => {
	const fallback = SEO_DATA.find((item) => item.page === page) || SEO_DATA[0];
	const pageTitle = title || fallback.title;
	const pageDescription = description || fallback.description;
	const pageKeywords = keywords || fallback.keywords || [];
	const pagePath = path || fallback.path || "/";
	const canonical = buildAbsoluteUrl(pagePath);
	const imageUrl = buildAbsoluteUrl(image || DEFAULT_IMAGE);
	const robots = noindex || fallback.noindex ? "noindex,follow" : "index,follow";
	const schemas = Array.isArray(schema) ? schema.filter(Boolean) : [schema].filter(Boolean);

	return (
		<Helmet>
			<title>{pageTitle}</title>
			<meta name="description" content={pageDescription} />
			<meta name="keywords" content={pageKeywords.join(", ")} />
			<meta name="robots" content={robots} />
			<link rel="canonical" href={canonical} />

			<meta property="og:site_name" content={INFO.main.name} />
			<meta property="og:title" content={pageTitle} />
			<meta property="og:description" content={pageDescription} />
			<meta property="og:type" content={type} />
			<meta property="og:url" content={canonical} />
			<meta property="og:image" content={imageUrl} />
			<meta property="og:locale" content="en_US" />

			<meta name="twitter:card" content="summary_large_image" />
			<meta name="twitter:title" content={pageTitle} />
			<meta name="twitter:description" content={pageDescription} />
			<meta name="twitter:image" content={imageUrl} />

			{schemas.map((schemaItem, index) => (
				<script type="application/ld+json" key={`${pageTitle}-schema-${index}`}>
					{JSON.stringify(schemaItem)}
				</script>
			))}
		</Helmet>
	);
};

export { buildAbsoluteUrl };
export default SEO;
